<template>
  <v-container>
    <v-dialog v-model="dialog" width="609" @click:outside="closeModal">
      <v-card class="custom-card" rounded="0">
        <v-toolbar color="secondary" class="white--text">
          <v-toolbar-title class="font-weight-bold" v-if="!note.id">{{
            $t("animal.addNewNote")
          }}</v-toolbar-title>

          <v-toolbar-title class="font-weight-bold" v-else>{{
            $t("animal.updateNote")
          }}</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn icon class="white--text" @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-form
          autocomplete="off"
          ref="form"
          v-model="valid"
          @submit.prevent="addNote"
        >
          <v-card-text class="black--text">
            <label class="title" for="name">{{ $t("animal.notes") }}</label>
            <v-textarea
              v-model="note.description"
              outlined
              class="mt-3"
              placeholder="Type Here"
              :rules="noteRules"
            ></v-textarea>

            <v-card-actions class="">
              <v-spacer></v-spacer>
              <v-btn
                class=""
                outlined
                color="primary"
                @click="closeModal"
                width="112"
              >
                {{ $t("cancel") }}
              </v-btn>
              <v-btn
                type="submit"
                width="112"
                color="primary"
                class="btn-11 btn-22"
                :disabled="note.description?.length > 50"
              >
              {{ !note.id ? $t("Submit") : $t("update") }}
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import loading from "@/mixins/LoadingMixin";

import gql from "graphql-tag";

export default {
  computed: {
    dialog() {
      return this.dialogI;
    },
  },
  mounted() {
    if (this.item.id) {
      this.note.id = parseInt(this.item.id);
      this.note.description = this.item.description;
    }
  },
  data() {
    return {
      note: {
        id: null,
        description: null,
        animalId: parseInt(this.$route.params.animal_number),
      },
      valid: true,
      noteRules: [
        (v) => !!v || this.$t("animal.noteIsRequired"),
        (v) =>
          (v && v.length <= 50) ||
          this.$t("animal.noteMustBeLessThan50Characters"),
      ],
    };
  },
  methods: {
    closeModal() {
      this.$emit("dialog:close");
    },
    addNote() {
      if(this.note.description == "" || this.note.description == null){
            this.$notify({
                  //title: `No details entered.`,
                  text: 'No details entered.',
                  type: "error",
                  position: "top right",
              });
          return;
      }
      this.note.description = this.note.description.trim()
      if(this.note.description.trim().length<1) return 
      if (!this.$refs.form.validate()) return;
      this.startLoading();
      const note = this.note;
      note.title = note.description;
      let mutation = "";

      if (!note.id) {
        delete note.id;
        mutation = `mutation ($data: CreateNoteInput!) {
              createNote(createNoteInput: $data) {
                id
              }
            }`;
      } else {
        mutation = `mutation ($data: UpdateNoteInput!) {
              updateNote(updateNoteInput: $data) {
                id
              }
            }`;
      }
      this.$apollo
        .mutate({
          mutation: gql`
            ${mutation}
          `,
          variables: {
            data: note,
          },
        })
        .then((respose) => {
          this.stopLoading();
          if (respose.data.createNote) {
            this.$notify({
              title: this.$t("animal.noteAdded"),
              type: this.$t("success"),
            });
            this.$emit("result:success");
            this.$emit("dialog:close");
          } else if (respose.data.updateNote) {
            this.$notify({
              title: this.$t("animal.noteUpdated"),
              type: this.$t("success"),
            });
            this.$emit("result:success");
            this.$emit("dialog:close");
          } else {
            console.log(respose);
            this.$notify({
              title: this.$t("animal.noteNotAdded"),
              type: this.$t("error"),
            });
            this.$emit("dialog:close");
          }
        })
        .catch((error) => {
          this.stopLoading();
          console.log("err", error);
        });
    },
  },

  props: ["dialogI", "item"],
  mixins: [loading],
};
</script>
<style lang="scss" scoped></style>
